import { render, staticRenderFns } from "./whzlDetail.vue?vue&type=template&id=6b17b6b3&scoped=true&"
import script from "./whzlDetail.vue?vue&type=script&lang=js&"
export * from "./whzlDetail.vue?vue&type=script&lang=js&"
import style0 from "./whzlDetail.vue?vue&type=style&index=0&id=6b17b6b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b17b6b3",
  null
  
)

export default component.exports